import { render } from "./ShouRuXingCaiPage.vue?vue&type=template&id=6bb65360&scoped=true"
import script from "./ShouRuXingCaiPage.vue?vue&type=script&lang=js"
export * from "./ShouRuXingCaiPage.vue?vue&type=script&lang=js"

import "./ShouRuXingCaiPage.vue?vue&type=style&index=0&id=6bb65360&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb65360"]])

export default __exports__